  <div class="container">
    <div class="slider-container">
        <div class="slider-content">
            <img src="assets/vectors/iconGroup.svg" class="slider-logo" alt="logo"/>
            <div class="heading">{{ 'app.weekly_report_otp_verification.stay_on_right_side_of_law' | translate }}</div>
            <div class="pagination-dots">
                <span class="pagination-dot active"></span>
                <span class="pagination-dot"></span>
                <span class="pagination-dot"></span>
            </div>
        </div>
    </div>
    <div class="otp-container">
      <div class="otp-form">
        <div class="logo">
          <img src="assets/vectors/RegTrackLogo.svg" [alt]="'app.weekly_report_otp_verification.company_logo' | translate" />
        </div>
        <h4>{{ 'app.weekly_report_otp_verification.otp_verification' | translate }}</h4>
        <p class="otp-subtitle">{{ 'app.weekly_report_otp_verification.enter_otp_sent_to_email' | translate }}</p>

        <div *ngIf="!isOtpSent" class="email-field">
          <button ejs-button type="button" class="login-btn" (click)="sendOtp()" [disabled]="isSendingOtp">
            {{ (isSendingOtp ? 'app.weekly_report_otp_verification.sending' : 'app.weekly_report_otp_verification.send_otp') | translate }}
          </button>
        </div>

        <form *ngIf="isOtpSent" #otpForm="ngForm" (ngSubmit)="verifyOtp()">
          <div class="input-group">
            <ejs-textbox
              class="textbox"
              [(ngModel)]="otp"
              name="otp"
              [placeholder]="'app.weekly_report_otp_verification.enter_otp' | translate"
              required
              #otpRef="ngModel"
              maxlength="6"
            ></ejs-textbox>
          </div>

          <div *ngIf="otpRef.invalid && otpRef.touched" class="error-msg">
            <span *ngIf="otpRef.errors?.['required']">{{ 'app.weekly_report_otp_verification.otp_is_required' | translate }}</span>
          </div>

          <div *ngIf="errorMessage" class="error-msg">
            {{ errorMessage }}
          </div>

          <div *ngIf="successMessage" class="success-msg">
            {{ successMessage }}
          </div>

          <div class="email-field">
              <button ejs-button type="submit" class="login-btn">{{ 'app.weekly_report_otp_verification.verify_otp' | translate }}</button>
          </div>

          <div class="resend-otp">
            <button class="resend-btn" type="button"
              [disabled]="isResendDisabled" (click)="resendOtp()">
              {{ 'app.weekly_report_otp_verification.resend_otp' | translate }} <span *ngIf="isResendDisabled">({{ resendTimer }}s)</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
